import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [youthDropdown, setYouthDropdown] = useState(false);
  const [hsDropdown, setHsDropdown] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="network-header">
      <div className="nav-wrapper">
        <Link to="/" className="network-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_d01a0992-11a4-4272-94cc-141f8b794a67/artifacts/x7simg37_IMG_3934.png" 
            alt="Pacific Ghost" 
            style={{ height: '50px', width: 'auto' }}
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="network-nav desktop-nav">
          <Link to="/" className={`network-nav-link ${isActive('/') ? 'active' : ''}`}>
            Home
          </Link>
          
          {/* Youth Teams Dropdown */}
          <div 
            className="nav-dropdown"
            onMouseEnter={() => setYouthDropdown(true)}
            onMouseLeave={() => setYouthDropdown(false)}
          >
            <button className="network-nav-link dropdown-trigger">
              Youth Teams <ChevronDown size={16} />
            </button>
            {youthDropdown && (
              <div className="dropdown-menu">
                <Link to="/team/10u" className="dropdown-item">10U</Link>
                <Link to="/team/11u" className="dropdown-item">11U</Link>
                <Link to="/team/12u" className="dropdown-item">12U</Link>
                <Link to="/team/13u" className="dropdown-item">13U</Link>
                <Link to="/team/14u" className="dropdown-item">14U</Link>
              </div>
            )}
          </div>

          {/* High School Dropdown */}
          <div 
            className="nav-dropdown"
            onMouseEnter={() => setHsDropdown(true)}
            onMouseLeave={() => setHsDropdown(false)}
          >
            <button className="network-nav-link dropdown-trigger">
              High School <ChevronDown size={16} />
            </button>
            {hsDropdown && (
              <div className="dropdown-menu">
                <Link to="/highschool/2026" className="dropdown-item">Class of 2026</Link>
                <Link to="/highschool/2027" className="dropdown-item">Class of 2027</Link>
                <Link to="/highschool/2028" className="dropdown-item">Class of 2028</Link>
                <Link to="/highschool/2029" className="dropdown-item">Class of 2029</Link>
                <Link to="/highschool/2030" className="dropdown-item">Class of 2030</Link>
              </div>
            )}
          </div>

          <Link to="/commits" className={`network-nav-link ${isActive('/commits') ? 'active' : ''}`}>
            Recent Commits
          </Link>
          <Link to="/showcase" className={`network-nav-link ${isActive('/showcase') ? 'active' : ''}`}>
            Showcases
          </Link>
          <Link to="/founders" className={`network-nav-link ${isActive('/founders') ? 'active' : ''}`}>
            Founders
          </Link>
          <Link to="/advisors" className={`network-nav-link ${isActive('/advisors') ? 'active' : ''}`}>
            Advisors
          </Link>
          <Link to="/player/login" className={`network-nav-link ${isActive('/player/login') || isActive('/player/dashboard') ? 'active' : ''}`}>
            Player Login
          </Link>
          <Link to="/contact" className="btn-primary-nav">
            Contact
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="mobile-menu-toggle" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="mobile-nav">
          <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
          
          <div className="mobile-dropdown">
            <button onClick={() => setYouthDropdown(!youthDropdown)} className="mobile-dropdown-trigger">
              Youth Teams <ChevronDown size={16} />
            </button>
            {youthDropdown && (
              <div className="mobile-dropdown-content">
                <Link to="/team/10u" onClick={() => setIsOpen(false)}>10U</Link>
                <Link to="/team/11u" onClick={() => setIsOpen(false)}>11U</Link>
                <Link to="/team/12u" onClick={() => setIsOpen(false)}>12U</Link>
                <Link to="/team/13u" onClick={() => setIsOpen(false)}>13U</Link>
                <Link to="/team/14u" onClick={() => setIsOpen(false)}>14U</Link>
              </div>
            )}
          </div>

          <div className="mobile-dropdown">
            <button onClick={() => setHsDropdown(!hsDropdown)} className="mobile-dropdown-trigger">
              High School <ChevronDown size={16} />
            </button>
            {hsDropdown && (
              <div className="mobile-dropdown-content">
                <Link to="/highschool/2026" onClick={() => setIsOpen(false)}>Class of 2026</Link>
                <Link to="/highschool/2027" onClick={() => setIsOpen(false)}>Class of 2027</Link>
                <Link to="/highschool/2028" onClick={() => setIsOpen(false)}>Class of 2028</Link>
                <Link to="/highschool/2029" onClick={() => setIsOpen(false)}>Class of 2029</Link>
                <Link to="/highschool/2030" onClick={() => setIsOpen(false)}>Class of 2030</Link>
              </div>
            )}
          </div>

          <Link to="/commits" onClick={() => setIsOpen(false)}>Recent Commits</Link>
          <Link to="/showcase" onClick={() => setIsOpen(false)}>Showcases</Link>
          <Link to="/founders" onClick={() => setIsOpen(false)}>Founders</Link>
          <Link to="/advisors" onClick={() => setIsOpen(false)}>Advisors</Link>
          <Link to="/player/login" onClick={() => setIsOpen(false)}>Player Login</Link>
          <Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link>
        </div>
      )}
    </nav>
  );
};

export default Navigation;